import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const StokesTheorem = () => (
  <QPhototModuleSubtopic
    title="Stokes"
    videos={[
      "https://www.youtube.com/embed/0twekAuex4k"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_78.jpeg"
        },
        {
            image:"/cal_79.jpeg"
        }
    ]}
    exampleVideos={[]}
  />
);

export default StokesTheorem;
